var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCombatlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168.07 168.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "69.05 158.9 9.25 99.1 11.24 68.83 99.33 156.91 69.05 158.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "168.07 9.67 55.53 122.21 69.9 136.59 159.46 32.88 168.07 9.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.17 0 135.27 8.69 31.57 98.25 46.74 113.43 160.17 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.95 149.63 25.33 121.86 29.96 117.23 50.66 137.93 38.95 149.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.69 168.42 0 147.72 40.52 107.2 42.41 146.7 20.69 168.42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCombatlog);
export default __webpack_public_path__ + "static/media/icon-combatlog.6e2fdf29d35385e7592c15f9c732158b.svg";
export { ForwardRef as ReactComponent };